  <template>
    <VueTelInput
      :model-value="modelValue"
      v-bind="inputProps"
      @update:model-value="updateValue"
    />
  </template>
<script setup>
  import { computed } from 'vue'
  import { VueTelInput } from 'vue-tel-input'
 
  const emit  = defineEmits(['update:modelValue'])
  const props = defineProps({
    modelValue: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'international',
    },
    inputOptions: {
      type: Object,
      default: () => ({ placeholder: '' }),
    },
    defaultCountry: {
      type: [String, Number],
      default: undefined,
    },
  })
  
  const inputProps = computed(() => ({
    mode: props.mode || 'international',
    inputOptions: props.inputOptions || { placeholder: '' },
    defaultCountry: props.defaultCountry,
  }))

  const updateValue = (value) => {
    emit('update:modelValue', value || '')
  }
    
  </script>
  <style> 
  .vue-tel-input{border-radius:3px;display:flex;border:1px solid #bbb;text-align:left}.vue-tel-input.disabled .selection,.vue-tel-input.disabled .dropdown,.vue-tel-input.disabled input{cursor:no-drop}.vue-tel-input:focus-within{box-shadow:inset 0 1px 1px #00000013,0 0 8px #66afe999;border-color:#66afe9}.vti__dropdown{display:flex;flex-direction:column;align-content:center;justify-content:center;position:relative;padding:7px;cursor:pointer}.vti__dropdown.show{max-height:300px;overflow:scroll}.vti__dropdown.open{background-color:#f3f3f3}.vti__dropdown.disabled{cursor:no-drop;outline:none;background-color:#f3f3f3}.vti__dropdown:hover{background-color:#f3f3f3}.vti__selection{font-size:.8em;display:flex;align-items:center}.vti__selection .vti__country-code{color:#666}.vti__flag{margin-right:5px;margin-left:5px}.vti__dropdown-list{z-index:1;padding:0;margin:0;text-align:left;list-style:none;max-height:200px;overflow-y:scroll;position:absolute;left:-1px;background-color:#fff;border:1px solid #ccc;width:390px}.vti__dropdown-list.below{top:33px}.vti__dropdown-list.above{top:auto;bottom:100%}.vti__dropdown-arrow{transform:scaleY(.5);display:inline-block;color:#666}.vti__dropdown-item{cursor:pointer;padding:4px 15px}.vti__dropdown-item.highlighted{background-color:#f3f3f3}.vti__dropdown-item.last-preferred{border-bottom:1px solid #cacaca}.vti__dropdown-item .vti__flag{display:inline-block;margin-right:5px}.vti__input{border:none;border-radius:0 2px 2px 0;width:100%;outline:none;padding-left:7px}.vti__search_box{border:1px solid #ccc;width:94%;padding:7px;margin:2px}
  .vti__flag.tr{height:14px;background-position:-5065px 0px}
  .vti__flag{width:20px}.vti__flag.be{width:18px}
  </style>
